import { HttpClient, HttpParams, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators'
import { environment } from 'src/environments/environment';
import { catchError, tap } from 'rxjs/operators';
import { PersonIncoming, Person, MainBar, TopBar, Screen, BusinessOutcoming } from '../../../../classes/Authorization/BusinessRole';


@Injectable()
export class HttpServiceAccount {

    constructor(private http: HttpClient) { }

    //BeautechWebAPI
    postDataLoginBeautech(personincoming: PersonIncoming) {
        const body = { login: personincoming.login, password: personincoming.password };
        console.log(JSON.stringify(body));
        return this.http.post(environment.urlservbeautech + '/api/Account', JSON.stringify(body));
    }

    getLoggedInUser() {
        return this.http.get<any>(environment.urlservbeautech + '/api/Values/GetBusinessRole');
    }

    getMainBar() {
        return this.http.get<any>(environment.urlservbeautech + '/api/Values/GetMainBar');
    }

    getTopBar() {
        return this.http.get<any>(environment.urlservbeautech + '/api/Values/GetTopBar');
    }

    getControlsByScreen(screen: Screen) {
        const body = { screen_id: screen.screen_id };
        return this.http.post(environment.urlservbeautech + '/api/Values/GetControlsSync', JSON.stringify(body));
    }

    getControlsByScreenAsync(screen: Screen) {
        const body = { screen_id: screen.screen_id };
        return this.http.post(environment.urlservbeautech + '/api/Values/GetControls', JSON.stringify(body));
    }


    removeBusinessByConstr(businessOut: BusinessOutcoming) {
        const body = { constr: businessOut.constr};
        return this.http.post(environment.urlservbeautech + '/api/Account/BusinessOut', JSON.stringify(body)).toPromise();
    }


}